import { Component } from '@angular/core';

@Component({
    selector: 'mveva',
    template: require('./mveva.component.html'),
})

export class MvevaComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/mveva/mveva.component.ts
 **/